import React, { Component } from 'react';
import { reactLoader } from '../helpers/Common';
const jQuery = window.jQuery;
export default class Tinyscroll extends Component {
  
  componentWillReceiveProps(nextProps) {
    let timer_count = 500;
    if (nextProps.count > 0) {
      timer_count = parseInt(nextProps.count) * 10;
    }
    reactLoader("show", "Please wait...");
    setTimeout(() => {
      let $scrollbar = jQuery('#' + nextProps.selector).tinyscrollbar();
      let scrollbarUpdate = $scrollbar.data("plugin_tinyscrollbar");
      if (scrollbarUpdate) {
        scrollbarUpdate.update('relative');
      }
      let self = nextProps;
      jQuery(document).on('click', '#module-wise a', function () {
        let $scrollbar = jQuery('#' + self.selector).tinyscrollbar();
        let scrollbarUpdate = $scrollbar.data("plugin_tinyscrollbar");
        let $scrollbarContent = jQuery('#semana-scroll').tinyscrollbar();
        if (scrollbarUpdate) {
          scrollbarUpdate.update('relative');
        }
        let scrollbarContent = $scrollbarContent.data("plugin_tinyscrollbar");
        if (scrollbarContent) {
          scrollbarContent.update('relative');
        }
      });
      jQuery(document).on('click', '#leftmenuarrow', function () {
        let $scrollbar = jQuery('#' + self.selector).tinyscrollbar();
        let scrollbarUpdate = $scrollbar.data("plugin_tinyscrollbar");
        if (scrollbarUpdate) {
          scrollbarUpdate.update('relative');
        }
      });
      reactLoader("hide");
    }, timer_count);
  }
  render() {
    return (
      <section id={this.props.selector} className="scrollbar1">
        <section className="scrollbar">
          <section className="track"><section className="thumb"></section></section>
        </section>
        {this.props.children}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/helpers/Tinyscroll.js